import { SellingCompanyReport } from '../../../../tms-shared';

export interface PickingListLabel {
  stockNo: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  reference: string;
  batchNo: string;
  grossQuantity: number;
  nettQuantity: number;
  tare: number;
  unitOfMeasure: string;
  name: string;
  orderNumber: number;
  cusSupOrderNumber: string;
  orderReference: string;
  lineReference: string;
  autoPrint: boolean;
  barcode: string;
  sellingCompanyName: string;
  composition: string;
  width: number;
  origin: string;
  care: string;
  location: string;
  stockDate: string;
  horizontalRepeat: string;
  verticalRepeat: string;
  pickDate: string;
  salesOrderRef: string;
  printAddressLabel: boolean;
  printStockLabel: boolean;

  sellingCompany: SellingCompanyReport;
}
